import {useEffect, useState} from "react";
import {doc, onSnapshot} from 'firebase/firestore'
import {fire} from "../../fire";
import {ad_user_usuario} from "../Auth/Adaptadores/ad_user_usuario";


export const useEscucharUsuarioToCorreo = ({correo = null, funcionNoExiste = null, user}) => {
    const [usuario, setUsuario] = useState(null)
    const [verificando, setVerificando] = useState(false)


    useEffect(() => {

        if (correo !== null) {
            setVerificando(true)
            let id = getID(correo);
            onSnapshot(doc(fire, "usuarios", id), (snap) => {
                if (snap.data() && snap.data().estado === 'Admin') {

                    let usuario = ad_user_usuario({user: user, usuario: snap.data()})

                    setUsuario(usuario)
                    setVerificando(false)

                } else {
                    if (funcionNoExiste !== null) {
                        funcionNoExiste()
                    }
                    setUsuario(null)
                    setVerificando(false)
                }
            })

        } else {
            setUsuario(null)
            setVerificando(false)
        }


    }, [correo])

    return {
        usuario,
        verificando
    }

}


export const getID = (email) => {
    let em = email.replaceAll("@", "_");
    let es = em.replaceAll(".", "-").toLocaleLowerCase();
    return es.replaceAll(' ', '')
}